import { render } from "./CertificateType.vue?vue&type=template&id=48d44171"
import script from "./CertificateType.vue?vue&type=script&lang=js"
export * from "./CertificateType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__